module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "margin-b-10",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'reports',
        query: {
          t: 'excise'
        },
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.reports.fees.title')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.excisePeriod.monthName))])], 1), _vm._v(" "), _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.reports.exciseEntry.title')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [(_vm.excisePeriod) ? _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": _vm.excisePeriod.monthName,
      "name": "1"
    }
  }, [(_vm.exciseReports.length) ? _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.exciseReports), function(exciseReport, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": "",
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('h3', {
      staticStyle: {
        "font-size": "1.1rem"
      }
    }, [(exciseReport.period) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('static.reports.fees.exciseStatus.closed')) + " (" + _vm._s(exciseReport.period) + ")")])]) : _vm._e(), _vm._v(" "), (!exciseReport.period) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t(("static.reports.fees.exciseStatus." + (_vm.camalize(_vm.excisePeriod.exciseStatus))))))]), _vm._v(" "), (_vm.excisePeriod.exciseStatus === 'Changed') ? _c('i', {
      staticClass: "header-icon el-icon-info"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
      staticClass: "margin-b-10",
      attrs: {
        "gutter": 20
      }
    }, [(!_vm.hasExcise) ? [_c('el-alert', {
      attrs: {
        "title": "For å hente avgifter   for rapportering må du abonnere på særavgift og lagermodul. Ta kontakt med support for mer info.",
        "type": "error",
        "closable": false
      }
    })] : [_c('el-col', {
      attrs: {
        "span": 24
      }
    })]], 2), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [(!exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Ready to be closed' || _vm.excisePeriod.exciseStatus === 'Changed')) ? _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-alert', {
      staticClass: "margin-b-10",
      attrs: {
        "title": "",
        "type": "warning",
        "closable": false,
        "show-icon": ""
      }
    }, [_vm._t("default", [_vm._v("\n                    " + _vm._s(_vm.excisePeriod.exciseStatus === 'Ready to be closed' ? _vm.$t('static.reports.fees.readyToCloseWarning') : _vm.$t('static.reports.fees.changedWarning')) + "\n                  ")])], 2), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center"
    }, [_c('el-button', {
      staticClass: "margin-b-20 text-center",
      attrs: {
        "loading": _vm.closeLoading
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.closePeriod($event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('static.reports.fees.closeButton')) + " " + _vm._s(_vm.excisePeriod.monthName) + "\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "mg": 12,
        "lg": 12,
        "xl": 6
      }
    }, [_c('fieldset', {
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.skatteetaten.title')) + " "), _c('span', {
      staticClass: "warning"
    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.skatteetaten.due_info')) + ")")])]), _vm._v(" "), (exciseReport.entries.length) ? [_vm._l((exciseReport.entries), function(item) {
      return [_c('div', {
        staticClass: "margin-b-10"
      }, [_c('label', {}, [_vm._v("\n                          " + _vm._s(item['group']) + " (" + _vm._s(item['description']) + "):\n                        ")]), _vm._v(" "), _c('span', {
        staticClass: "label-content label-content--small"
      }, [_vm._v("\n                          " + _vm._s(item['totalVolume']) + "\n                          " + _vm._s(item['unitType']) + "\n                        ")])])]
    }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-col', [(exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus ===
      'Changed')) ? _c('el-button', {
      staticClass: "small dark-outline",
      on: {
        "click": function($event) {
          return _vm.downloadExciseReport(exciseReport.period)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus ===
      'Changed')) ? _c('el-button', {
      staticClass: "small dark-outline",
      staticStyle: {
        "color": "#F56C6C",
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.downloadExciseReport(exciseReport.period, 'csv')
        }
      }
    }, [_vm._v("\n                        BETA! " + _vm._s(_vm.$t('static.reports.fees.exportCsv')) + "\n                      ")]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (!exciseReport.entries.length) ? _c('el-alert', {
      attrs: {
        "title": _vm.$t('static.reports.noData'),
        "type": "warning",
        "closable": false
      }
    }) : _vm._e()], 2)]), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "mg": 12,
        "lg": 12,
        "xl": 6
      }
    }, [_c('fieldset', {
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.helsedir.title')) + " "), _c('span', {
      staticClass: "warning"
    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.helsedir.due_info')) + ")")])]), _vm._v(" "), [(!_vm.getHelsedirReportByPeriod(exciseReport.period)) ? _c('el-alert', {
      attrs: {
        "title": _vm.$t('static.reports.noData'),
        "type": "warning",
        "closable": false
      }
    }) : [_c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {}, [_vm._v("\n                          Gruppe 1 (2,6% - 4,7%):\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_1.liters).toFixed(2)) + " liter\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {}, [_vm._v("\n                          Gruppe 2 (4,8% - 21,9%):\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_2.liters).toFixed(2)) + " liter\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [_c('label', {}, [_vm._v("\n                          Gruppe 3 (22% - 60%):\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "label-content label-content--small"
    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_3.liters).toFixed(2)) + " liter\n                        ")])])]]], 2)]), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "mg": 12,
        "lg": 12,
        "xl": 6
      }
    }, [_c('fieldset', {
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.brod.title')) + " "), _c('span', {
      staticClass: "warning"
    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.brod.due_info')) + ")")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [(!exciseReport.entries.length) ? _c('el-alert', {
      attrs: {
        "title": _vm.$t('static.reports.noData'),
        "type": "warning",
        "closable": false
      }
    }) : _vm._e(), _vm._v(" "), (exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus === 'Changed')) ? _c('el-button', {
      staticClass: "small dark-outline",
      on: {
        "click": function($event) {
          return _vm.downloadBrodReport(exciseReport.period)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.reports.brod.export')) + "\n                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 24,
        "mg": 12,
        "lg": 12,
        "xl": 6
      }
    }, [_c('fieldset', {
      staticClass: "margin-b-10"
    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.infinitum.title')) + " "), _c('span', {
      staticClass: "warning"
    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.infinitum.due_info')) + ")")])]), _vm._v(" "), _c('div', {
      staticClass: "margin-b-10"
    }, [(!_vm.getInfinitumReportByPeriod(exciseReport.period)) ? _c('el-alert', {
      attrs: {
        "title": _vm.$t('static.reports.noData'),
        "type": "warning",
        "closable": false
      }
    }) : _vm._l((_vm.getInfinitumReportByPeriod(exciseReport.period)), function(item) {
      return _c('div', {
        staticClass: "margin-b-10"
      }, [_c('label', {}, [_vm._v("\n                          " + _vm._s(item.product_name) + ":\n                        ")]), _vm._v(" "), _c('span', {
        staticClass: "label-content label-content--small"
      }, [_vm._v("\n                          " + _vm._s(item.qty) + "\n                        ")])])
    })], 2)])])], 1)], 2)
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.reports.exciseEntryLabel'),
      "name": "2"
    }
  }, [(_vm.exciseEntryDate !== null) ? _c('v-excise-entry', {
    attrs: {
      "exciseDate": _vm.exciseEntryDate
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec09d0c","hasScoped":false}!./src/app/pages/withNavigation/exciseReport/exciseReport.html
// module id = 3079
// module chunks = 1